import { getHpMarketingInfoUseCase } from '@/domain/use-cases/get-hp-markeing-info.use-case';
import { Result } from '@/entities';
import { MarketingModuleDto } from '@/infrastructure/network/dto/HpMarketingModuleDto';

export const getHpMarketingInfoController = async (hpMarketingType: string): Promise<Result<MarketingModuleDto>> => {
	return getHpMarketingInfoUseCase(hpMarketingType);
};
